// extracted by mini-css-extract-plugin
module.exports = {"navBack":"NavBack_navBack__1Ovx-","customLink":"NavBack_customLink__1oA_s","arrow":"NavBack_arrow__38zZo","left":"NavBack_left__2PNcB","customMargin":"NavBack_customMargin__3dIHj"};